"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("../../components/utils/helpers");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    root: {
      '& .MuiOutlinedInput-root[color="primary"]': {
        '& .MuiOutlinedInput-input': {
          '&>em': {
            fontWeight: '500',
            opacity: 0.5
          },
          color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
          fontSize: isFontBigger ? '20px' : '16px',
          fontWeight: 'bold',
          padding: '10px 35px 10px 12px'
        },
        '& .MuiOutlinedInput-underline:after': {
          display: 'none'
        },
        '& .MuiOutlinedInput-underline:before': {
          display: 'none'
        },
        '& .MuiSvgIcon-root': {
          color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
          top: '17px'
        },
        '&.Mui-focused': {
          borderWidth: 2
        },
        '&:hover': {
          backgroundColor: _helpers.agentDeveloperUtils.getPrimaryColor(120)
        },
        backgroundColor: 'white',
        border: 'none',
        borderRadius: 20,
        color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
        fontSize: isFontBigger ? '20px' : '16px',
        height: '40px',
        lineHeight: '20px',
        overflow: 'hidden'
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      },
      '& .MuiSvgIcon-root.MuiSelect-icon': {
        '& path': {
          d: 'path("M12,15.7l-7.6-5.4C4,10,3.9,9.4,4.2,8.9c0.3-0.5,0.9-0.6,1.4-0.2l6.4,4.6l6.4-4.6c0.4-0.3,1.1-0.2,1.4,0.2c0.3,0.4,0.2,1.1-0.2,1.4L12,15.7z")'
        },
        color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(195) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
        height: '24px',
        margin: 0,
        right: '12px',
        width: '24px'
      }
    }
  };
};
exports.default = _default;